import './modal-challenge-stats.scss';
import { useState } from 'react';
import Button from '../button/button';
import ModalTemplate from '../modal-template/modal-template';
import UtilsService from '../../services/utils-service';
import LocalStorage from '../../services/local-storage';
import { ASSETS, SESSION } from '../../constants';
import TranslateService from '../../services/translate-service';

export default function ModalChallengeStats(props) {

    const [session] = useState(LocalStorage.get(SESSION));

    return (
        <ModalTemplate isOpen={props.isOpen} className="modal-challenge-stats" >
            {props.data &&
                <>
                    <div className='text-center mb-[40px]'>
                        <h1 className='heading-h3'>{props.data.title}</h1>
                    </div>
                    <div className='grid gap-[16px] grid-cols-12'>
                        <div className='col-span-8 col-start-3'>

                            <div className='grid gap-[16px] grid-cols-12 items-center  mb-[11px]'>
                                <div className='col-span-4 '>
                                    <div className='text-center'>
                                        <div className='rounded-full avatar'>
                                            <img src={ `${ASSETS.AVATAR_PLAYER}${session.avatar}`} alt='' className='rounded-full m-auto w-[48px]' />
                                        </div>
                                        <h1 className='heading-h5 mt-1'>You</h1>
                                        <p className='heading-h6 !text-secundary mt-1'>{ UtilsService.format(props.data.jugador.puntosAreas.puntos) }pts</p>
                                    </div>
                                </div>

                                <div className='col-span-4 '>
                                    <div className='text-center'>
                                        <h1 className='heading-h5'>VS</h1>
                                    </div>
                                </div>
                                <div className='col-span-4 '>
                                    <div className='text-center'>
                                        <div className='rounded-full avatar'>
                                            <img src={ `${ASSETS.AVATAR_PLAYER}${props.data.oponente.avatar}`} alt='' className='rounded-full m-auto w-[48px]' />
                                        </div>
                                        <h1 className='heading-h5 mt-1'>{ UtilsService.formatPlayerName(props.data.oponente.nombre, props.data.oponente.apellidoPaterno) }</h1>
                                        <p className='heading-h6 !text-secundary mt-1'>{ UtilsService.format(props.data.oponente.puntosAreas.puntos) }pts</p>
                                    </div>
                                </div>
                            </div>



                            <div className='grid gap-[16px] grid-cols-12 items-center  mb-[49px]'>
                                <div className='col-span-12 '>

                                    <div className='card !rounded-[20px] !p-[24px]'>

                                        <div className='grid gap-[16px] grid-cols-12 items-center pb-6 separator-bottom'>
                                            <div className='col-span-3 '>
                                                <p className='text-heading-default'>{props.data.jugador.posicion}</p>
                                            </div>
                                            <div className='col-span-6 text-center'>
                                                <p className='text-secundary'>{TranslateService.get('stats.modal.challenge.rank')}</p>
                                            </div>
                                            <div className='col-span-3 text-right'>
                                                <p className='text-heading-default'>{props.data.oponente.posicion}</p>
                                            </div>
                                        </div>

                                        <div className='grid gap-[16px] grid-cols-12 items-center  mt-6'>
                                            <div className='col-span-3 '>
                                                <p className='text-heading-default'>{props.data.jugador.rondasJugadas}</p>
                                            </div>
                                            <div className='col-span-6 text-center'>
                                                <p className='text-secundary'>{TranslateService.get('stats.modal.challenge.played')}</p>
                                            </div>
                                            <div className='col-span-3 text-right'>
                                                <p className='text-heading-default'>{props.data.oponente.rondasJugadas}</p>
                                            </div>
                                        </div>

                                        <div className='grid gap-[16px] grid-cols-12 items-center mt-6'>
                                            <div className='col-span-3 '>
                                                <p className='text-heading-default'>{props.data.jugador.rondasGanadas}</p>
                                            </div>
                                            <div className='col-span-6 text-center'>
                                                <p className='text-secundary'>{TranslateService.get('stats.modal.challenge.won')}</p>
                                            </div>
                                            <div className='col-span-3 text-right'>
                                                <p className='text-heading-default'>{props.data.oponente.rondasGanadas}</p>
                                            </div>
                                        </div>

                                        <div className='grid gap-[16px] grid-cols-12 items-center mt-6'>
                                            <div className='col-span-3 '>
                                                <p className='text-heading-default'>{props.data.jugador.rondasPerdidas}</p>
                                            </div>
                                            <div className='col-span-6 text-center'>
                                                <p className='text-secundary'>{TranslateService.get('stats.modal.challenge.lost')}</p>
                                            </div>
                                            <div className='col-span-3 text-right'>
                                                <p className='text-heading-default'>{props.data.oponente.rondasPerdidas}</p>
                                            </div>
                                        </div>

                                        <div className='grid gap-[16px] grid-cols-12 items-center mt-6'>
                                            <div className='col-span-3 '>
                                                <p className='text-heading-default'>{props.data.jugador.insignias}</p>
                                            </div>
                                            <div className='col-span-6 text-center'>
                                                <p className='text-secundary'>{TranslateService.get('stats.modal.challenge.badges')}</p>
                                            </div>
                                            <div className='col-span-3 text-right'>
                                                <p className='text-heading-default'>{props.data.oponente.insignias}</p>
                                            </div>
                                        </div>

                                        <div className='grid gap-[16px] grid-cols-12 items-center mt-6'>
                                            <div className='col-span-3 '>
                                                <p className='text-heading-default'>{props.data.jugador.efectividad}%</p>
                                            </div>
                                            <div className='col-span-6 text-center'>
                                                <p className='text-secundary'>{TranslateService.get('stats.modal.challenge.accuracy')}</p>
                                            </div>
                                            <div className='col-span-3 text-right'>
                                                <p className='text-heading-default'>{props.data.oponente.efectividad}%</p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className='text-center'>
                                <Button className='small !px-[31px]' onClick={props.onClose}>{TranslateService.get('stats.modal.challenge.btn')}</Button>
                            </div>

                        </div>
                    </div>
                </>
            }

        </ModalTemplate>
    )
}